import { defineComponent as _defineComponent } from 'vue'
import { ref, shallowRef } from "vue";
import {
  DEFAULT_DATE_FIELDS,
  DEFAULT_DATE_PICKER_OPTIONS,
  DEFAULT_DATE_QUERY_TYPES,
  DEFAULT_TEXT_FIELDS,
} from "@/app-data/patent-query";
import { FieldEntity, FieldQueryType } from "@/types";
import cloneDeep from "lodash/cloneDeep";

import AdvSearchDialog from "./AdvSearchDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PatentSearchBar',
  emits: ["search", "adv-search"],
  setup(__props, { emit }) {



const advSearchDialogRef = shallowRef<any>();
const condition = ref({
  dateField: "",
  dateQueryType: "",
  keyWord: "",
  textField: "",
  dateQueryRange: [],
  dateQueryYear: null,
});
const advQueryStr = ref("");

const dateFields: Array<FieldEntity> = cloneDeep(DEFAULT_DATE_FIELDS);
const dateQueryTypes: Array<FieldQueryType> = cloneDeep(DEFAULT_DATE_QUERY_TYPES);
const textFields: Array<FieldEntity> = cloneDeep(DEFAULT_TEXT_FIELDS);
const datePickerOptions: any = cloneDeep(DEFAULT_DATE_PICKER_OPTIONS);

const onSearch = () => {
  emit("search", condition.value);
};

const openAdvSearch = () => {
  advSearchDialogRef.value.open();
};

const onAdvSearch = (condStr: string) => {
  advQueryStr.value = condStr;
  emit("adv-search", condStr);
};

return { __sfc: true,emit, advSearchDialogRef, condition, advQueryStr, dateFields, dateQueryTypes, textFields, datePickerOptions, onSearch, openAdvSearch, onAdvSearch, AdvSearchDialog }
}

})